export function getDynamicIslandDataFromState() {
  const {
    designSystem,
    state,
    components,
    snippets,
    pages,
    functions,
    methods,
    files,
    dependencies
  } = this.getData()

  return {
    designSystem,
    state,
    components,
    snippets,
    pages,
    functions,
    methods,
    files,
    dependencies
  }
}

export function getActiveDynamicIslandCategory() {
  return this.getFilesSidebar()?.state?.activeFileSidebar || 'Local'
}

export function getSidebarContent() {
  return this.getFilesSidebar()?.state?.activeContent
}

export async function setSidebarContent(activeContent) {
  // canvas's v2 body when canvas is loaded (one owner per name — canvas registers canvasSetSidebarContent)
  const _canvasFork = this?.context?.methods?.canvasSetSidebarContent
  if (typeof _canvasFork === 'function') return _canvasFork.apply(this, arguments)
  if (this.isEmbed()) return
  await this.getFilesSidebar()?.state.update({ activeContent })
  this.call('setCookie', this.getAppKey() + '_activeContent', activeContent)
  return activeContent
}

export function getActiveSidebarTypes(contentKey = this.call('getSidebarContent')) {
  return this.call('getTypes', contentKey)
}

export function isTypeSidebarActive(type) {
  return this.call('getActiveSidebarTypes').includes(type)
}

export function setActiveDynamicIslandCategory(category) {
  this.getFilesSidebar().state.update({ activeFileSidebar: category })
}

// TODO: check if its calling is using await
export async function getDynamicIslandDataByCategory(activeFileSidebar) {
  if (!activeFileSidebar) return
  const category = activeFileSidebar.toLowerCase()
  if (category === 'local') {
    return this.call('getDynamicIslandDataFromState')
  } else if (category === 'builtins') {
    return {} // BUILTINS_LIBRARY
  } else if (category === 'shared libraries') {
    return await this.getDefaultDesignSystem()
  }
}

export function toggleRenameInput(type, key) {
  // One-argument predicate contract (see findFileSidebarSection below). This
  // site had no short-circuit guard in front of the state read, so the 2-arg
  // form threw on the FIRST candidate — rename never opened.
  const listEl = this.getDynamicIsland().lookdown(
    (candidate) => candidate.state?.key === key && candidate.state?.type === type
  )

  if (!listEl) return

  listEl.state.update({ editing: true })
  const t = setTimeout(() => {
    listEl.Rename.Label.Input.node.select()
    clearTimeout(t)
  }, 0)
}

export function findFileSidebarSection(type) {
  const sidebar = this.getFilesSidebar()
  if (!sidebar || typeof sidebar.lookdown !== 'function') {
    return
  }
  // `lookdown` invokes its predicate with ONE argument (the candidate element),
  // so a 2-arg `(el, s)` form leaves `s` undefined and throws the moment a
  // candidate satisfies the left side. Read state off the element instead.
  return sidebar.lookdown(
    (candidate) => candidate.FilesSidebarList && candidate.state?.type === type
  )
}

export function findFileSidebarItem(type, key) {
  const section = this.call('findFileSidebarSection', type)
  if (!section) {
    return
  }
  // Same one-argument predicate contract as findFileSidebarSection above.
  return section.lookdown((candidate) => candidate.Rename && candidate.state?.key === key)
}

export async function rerenderFileSidebarByType(type, opts) {
  if (!this.getFilesSidebar()) {
    return
  }
  const section = this.call('findFileSidebarSection', type)
  if (!section) {
    return
  }

  return await section.update({}, opts)
}
